'use exports';

//make sure properties are in hyphenated form
module.exports = {
  'animation': 1,
  'column-count': 1,
  'columns': 1,
  'font-weight': 1,
  'opacity': 1,
  'order  ': 1,
  'z-index': 1,
  'zoom': 1,
  'flex': 1,
  'box-flex': 1,
  'transform': 1,
  'perspective': 1,
  'box-pack': 1,
  'box-align': 1,
  'colspan': 1,
  'rowspan': 1
};